/** Mo–So (0 = Sonntag, wie Date.getDay). */
const SCHEDULE = {
  0: { open: [16, 0], close: [22, 0] },
  1: { open: [16, 0], close: [22, 0] },
  2: null,
  3: null,
  4: { open: [16, 0], close: [22, 0] },
  5: { open: [16, 0], close: [22, 30] },
  6: { open: [16, 0], close: [22, 30] },
}

const SHORT_DAY_DE = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"]

const WD_FROM_EN = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }

function minutesOf([h, m]) {
  return h * 60 + m
}

function formatHm([h, m]) {
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`
}

function formatVonBis(sched) {
  return `von ${formatHm(sched.open)} bis ${formatHm(sched.close)}`
}

function berlinWeekdayAndMinutes(date) {
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone: "Europe/Berlin",
    weekday: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  })
  const parts = formatter.formatToParts(date)
  let weekdayAbbr
  let hour = 0
  let minute = 0
  for (const p of parts) {
    if (p.type === "weekday") weekdayAbbr = p.value
    if (p.type === "hour") hour = parseInt(p.value, 10)
    if (p.type === "minute") minute = parseInt(p.value, 10)
  }
  const weekDay = WD_FROM_EN[weekdayAbbr]
  const mins = hour * 60 + minute
  return { weekDay, mins }
}

/**
 * Nur development: sessionStorage kyoto_mock_now oder GATSBY_MOCK_NOW.
 */
export function getKyotoSimulatedNow() {
  if (process.env.NODE_ENV !== "development") {
    return new Date()
  }
  if (typeof window !== "undefined") {
    try {
      const s = window.sessionStorage.getItem("kyoto_mock_now")
      if (s) {
        const d = new Date(s)
        if (!Number.isNaN(d.getTime())) return d
      }
    } catch (e) {
      /* ignore */
    }
  }
  const envMock = process.env.GATSBY_MOCK_NOW
  if (envMock) {
    const d = new Date(envMock)
    if (!Number.isNaN(d.getTime())) return d
  }
  return new Date()
}

/** @returns {{ isOpen: boolean, detail: string }} */
export function computeKyotoOpeningLines(now) {
  const { weekDay, mins } = berlinWeekdayAndMinutes(now)
  const today = SCHEDULE[weekDay]

  if (today) {
    const openM = minutesOf(today.open)
    const closeM = minutesOf(today.close)
    if (mins >= openM && mins < closeM) {
      return {
        isOpen: true,
        detail: formatVonBis(today),
      }
    }
    if (mins < openM) {
      return {
        isOpen: false,
        detail: formatVonBis(today),
      }
    }
  }

  for (let delta = 1; delta <= 7; delta++) {
    const day = (weekDay + delta) % 7
    const sched = SCHEDULE[day]
    if (!sched) continue
    return {
      isOpen: false,
      detail: `${SHORT_DAY_DE[day]} ${formatVonBis(sched)}`,
    }
  }

  return { isOpen: false, detail: "" }
}

/**
 * Klartext für aktuelle Situation (Europe/Berlin).
 * @returns {{ isOpen: boolean, title: string, subtitle: string }}
 */
export function computeKyotoOpeningDisplay(now) {
  const lines = computeKyotoOpeningLines(now)
  const { weekDay, mins } = berlinWeekdayAndMinutes(now)
  const today = SCHEDULE[weekDay]

  if (today) {
    const openM = minutesOf(today.open)
    const closeM = minutesOf(today.close)
    if (mins >= openM && mins < closeM) {
      return {
        isOpen: true,
        title: "Jetzt geöffnet",
        subtitle: `bis ${formatHm(today.close)} Uhr`,
      }
    }
    if (mins < openM) {
      return {
        isOpen: false,
        title: "Noch geschlossen",
        subtitle: `Öffnet heute um ${formatHm(today.open)} Uhr`,
      }
    }
    return {
      isOpen: false,
      title: "Heute bereits geschlossen",
      subtitle: lines.detail ? `Weiter: ${lines.detail}` : "",
    }
  }

  return {
    isOpen: false,
    title: "Heute geschlossen",
    subtitle: lines.detail || "",
  }
}
